import { ProductStrengthsLine } from 'Components/lines/product-strengths-line/ProductStrengthsLine';
export default ProductStrengthsLine;
